import { z } from 'zod';
import { ReceivingSessionSchema } from './receiving';

// Zod schemas for the payload (NOT the wire message) of each inbound
// receiving-related WS action. The WS layer owns the `action` field — these
// schemas intentionally contain only domain fields.

export const receivingSessionUpdatedPayloadSchema = z.object({
  session: ReceivingSessionSchema,
  // Transient one-shot hint, set by the backend only when a Resume probe was
  // refused (companion replied rcv_resume_result{ready:false}). Never persisted
  // on the session; absent on every routine broadcast.
  probe_refused: z.boolean().default(false),
  // Abandon-side analogue of probe_refused: set only when the companion refused
  // the Abandon clear with rcv_clear_result{busy:true} (LPOS holds the file —
  // session kept alive unchanged). Never persisted; absent on routine broadcasts.
  abandon_busy: z.boolean().default(false),
});

export type ReceivingSessionUpdatedPayload = z.infer<typeof receivingSessionUpdatedPayloadSchema>;

export const companionStatusChangedPayloadSchema = z.object({
  machine_id: z.string(),
  connected: z.boolean(),
});

export type CompanionStatusChangedPayload = z.infer<typeof companionStatusChangedPayloadSchema>;

export const sessionLeaseReleasedPayloadSchema = z.object({
  session_id: z.string(),
});

export type SessionLeaseReleasedPayload = z.infer<typeof sessionLeaseReleasedPayloadSchema>;

export const storeUpdatedPayloadSchema = z.object({
  store_id: z.string(),
  // RFC3339 string (NOT a date schema): the WS provider parses without
  // coercion, under which a date schema would reject the string and skip the
  // handler. Optional/nullable so an older backend that omits it still
  // validates.
  last_uploaded_at: z.string().nullable().optional(),
});

export type StoreUpdatedPayload = z.infer<typeof storeUpdatedPayloadSchema>;
